if (window.jQuery) {
    (function($, sitenav) {
        "use strict";
        sitenav = sitenav || (window.sitenav = {});
        sitenav.App = sitenav.App || (sitenav.App = {});

        sitenav.App.ReturnUrlBuilder = {
            appendReturnUrl: function() {
                var currentUrl = location.href;

                $(".append-return-url").each(function(idx, data) {
                    var href = $(data).attr("href");

                    var signOutLink = $(data).data("signout");
                    var shouldAppend = !(signOutLink && href.indexOf(location.host) > -1);

                    if (shouldAppend)
                    {
                        if (href.indexOf("?") > -1)
                            href += "&";
                        else
                            href += "?";

                        // if its seller.carsalesnetwork then we always want to return to the homepage of the hero site
                        if (currentUrl.indexOf('seller.carsalesnetwork') > -1)
                        {
                            var heroSiteDomain = $(data).data("hero-site-domain");

                            if (heroSiteDomain.indexOf('http://') == -1)
                            {
                                heroSiteDomain = 'http://' + heroSiteDomain;
                            }

                            href += "src=sitenav&ret=" + encodeURIComponent(heroSiteDomain);
                        }
                        else {

                            href += "src=sitenav&ret=" + encodeURIComponent(currentUrl);
                        }

                        var tracking = $(data).data("tracking");
                        if (tracking && tracking.length > 0)
						{
                            href += "&" + tracking;
						}

                        $(data).attr("href", href);
                    }
                });
            }
        };

        sitenav.App.ReturnUrlBuilder.appendReturnUrl();
    }(jQuery, window.sitenav));
}


// WEBPACK FOOTER //
// ./Content/js/csn_returnurl.js